import vacationsAbsencesRouting from './vacationsAbsencesRouting/vacationsAbsencesRouting';
import myVacations from './myVacations/myVacations';
import myVacationsMobile from './myVacationsMobile/myVacationsMobile';
import teamRequests from './teamRequests/teamRequests';
import teamCalendar from './teamCalendar/teamCalendar';
import teamCalendarMobile from './teamCalendarMobile/teamCalendarMobile';
import managerAsEmployeeCalendar from './managerAsEmployeeCalendar/managerAsEmployeeCalendar';
import managerAsEmployeeCalendarMobile from './managerAsEmployeeCalendarMobile/managerAsEmployeeCalendarMobile';
import vacationsAbsencesDelegations from './vacationsAbsencesDelegations/vacationsAbsencesDelegations';
import periodListMobile from './periodListMobile/periodListMobile';
import scheduleMobile from './scheduleMobile/scheduleMobile';

let vacationsAbsencesFeatures = angular.module('vacations-absences.features', [
  vacationsAbsencesRouting,
  myVacations,
  myVacationsMobile,
  teamRequests,
  teamCalendar,
  teamCalendarMobile,
  managerAsEmployeeCalendar,
  managerAsEmployeeCalendarMobile,
  vacationsAbsencesDelegations,
  periodListMobile,
  scheduleMobile
])

  .name;

export default vacationsAbsencesFeatures;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/vacations-absences.features.js